export class MessagingCostEntity {
    id;
    smsPrice;
    emailPrice;
    siteId;

    constructor(id, smsPrice, emailPrice, siteId) {
        this.id = id;
        this.smsPrice = smsPrice;
        this.emailPrice = emailPrice;
        this.siteId = siteId;
    }
}